"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

// The paper is a file (public/preview-assets/quickproof/paper.pdf), not a page: a plain link, never current.
const LINKS = [
  { href: "/quickproof/paper.pdf", label: "PAPER", file: true },
  { href: "/quickproof/docs", label: "DOCS" },
  { href: "/quickproof/proofs", label: "PROOFS" },
];

// The product's sections, as small mono labels (quickproof.css, .qp-subnav and .qp-topbar-nav). `vertical` is the list at the top of a
// page's left column; the plain form is the row under the logo, shown only where there is no left column.
export default function ProductNav({ github, vertical = false }: { github: string; vertical?: boolean }) {
  const pathname = (usePathname() ?? "").replace(/^\/preview(?=\/|$)/, "");
  const items = [
    ...LINKS.map((l) => {
      if (l.file) {
        return (
          <a key={l.href} href={l.href}>
            [{l.label}]
          </a>
        );
      }
      const active = pathname === l.href || pathname.startsWith(l.href + "/");
      return (
        <Link key={l.href} href={l.href} aria-current={active ? "page" : undefined}>
          [{l.label}]
        </Link>
      );
    }),
    <a key="github" href={github} className="qp-topbar-gh" rel="noopener noreferrer">
      [GITHUB]
    </a>,
  ];
  if (vertical) {
    return (
      <nav className="qp-subnav" aria-label="QuickProof">
        <ul>
          {items.map((item) => (
            <li key={item.key}>{item}</li>
          ))}
        </ul>
      </nav>
    );
  }
  return (
    <nav className="qp-topbar-nav" aria-label="QuickProof">
      {items}
    </nav>
  );
}
